import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Contato from "./pages/Contato";
import DiagnosticoPatrimonial from "./pages/DiagnosticoPatrimonial";
import Obrigado from "./pages/Obrigado";
import ObrigadoAlt from "./pages/ObrigadoAlt";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ScrollToTop />
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/diagnostico-patrimonial" element={<DiagnosticoPatrimonial />} />
          <Route path="/obrigado" element={<Obrigado />} />
          <Route path="/obrigado-alt" element={<ObrigadoAlt />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </TooltipProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
